/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
const setupProductcateogrys = function(val){
  return val.map(x=>JSON.parse(x.value).name)
}
const setupAllProductcateogrys =function(title1,list1,title2,list2,title3){
  return [
    {
      title: title1,
      color: "active-red",
      items: list1.map(x=>JSON.parse(x.value).name)
    },
    {
      title: title2,
      color: "active-blue",
      items: list2.map(x=>JSON.parse(x.value).name)
    },
    {
      title: title3,
      color: "active-black",
      items: [],
    },
  ]
}
const setupProducts = function(val){
  return val.map(x=>JSON.parse(x.value))
}
const mutations = {
  /**
   * @name 返回顶部
   * @param {*} state
   * @param {*} val
   */
  SET_RETURNS(state, val) {
    state.returnEnable = val;
  },
  SET_NAV(state, val) {
    state.navEnable = val;
  },
  UPDATE_FOOTER(state, val) {
    state.product1List = val.list1;
    state.product2List = val.list2;
  },
  /**
   * @name 设置语言
   * @param {*} state 
   * @param {*} val 
   */
  SET_LANG(state, val){
    state.lang=val;
  },
  UPDATE_PRODUCTCATREGORY(state, val){
    state.product1List = setupProductcateogrys(val.list1)
    state.product2List =  setupProductcateogrys(val.list2)
  },
  UPDATE_ALLPRODUCTCATREGORY(state, val){
    state.allproductcategorys =  setupAllProductcateogrys(val.title1,val.list1,val.title2,val.list2,val.title3)
  },
  UPDATE_PRODUCTS(state, val){
    state.products= state.products.concat(setupProducts(val.list));
    state.productstotal=val.total
  },

  UPDATE_HOME(state,val){
    console.log(val)
    state.leftproductimg=val.homeleft.img
    state.rightproductimg=val.homeright.img
  }
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  // TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
  //   state.isVerticalNavMenuActive = value
  // },
  // TOGGLE_REDUCE_BUTTON(state, val) {
  //   state.reduceButton = val
  // },
  // UPDATE_MAIN_LAYOUT_TYPE(state, val) {
  //   state.mainLayoutType = val
  // },
  // UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
  //   state.verticalNavMenuItemsMin = val
  // },
  // UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
  //   state.verticalNavMenuWidth = width
  // },

  // // VxAutoSuggest

  // UPDATE_STARRED_PAGE(state, payload) {

  //   // find item index in search list state
  //   const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)

  //   // update the main list
  //   state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

  //   // if val is true add it to starred else remove
  //   if (payload.val) {
  //     state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
  //   }
  //   else {
  //     // find item index from starred pages
  //     const index = state.starredPages.findIndex((item) => item.url == payload.url)

  //     // remove item using index
  //     state.starredPages.splice(index, 1)
  //   }
  // },

  // // Navbar-Vertical

  // ARRANGE_STARRED_PAGES_LIMITED(state, list) {
  //   const starredPagesMore = state.starredPages.slice(10)
  //   state.starredPages = list.concat(starredPagesMore)
  // },
  // ARRANGE_STARRED_PAGES_MORE(state, list) {
  //   let downToUp = false
  //   let lastItemInStarredLimited = state.starredPages[10]
  //   const starredPagesLimited = state.starredPages.slice(0, 10)
  //   state.starredPages = starredPagesLimited.concat(list)

  //   state.starredPages.slice(0, 10).map((i) => {
  //     if (list.indexOf(i) > -1) downToUp = true
  //   })

  //   if (!downToUp) {
  //     state.starredPages.splice(10, 0, lastItemInStarredLimited)
  //   }
  // },

  // // ////////////////////////////////////////////
  // // UI
  // // ////////////////////////////////////////////

  // TOGGLE_CONTENT_OVERLAY(state, val) { state.bodyOverlay = val },
  // UPDATE_PRIMARY_COLOR(state, val) { state.themePrimaryColor = val },
  // UPDATE_THEME(state, val) { state.theme = val },
  // UPDATE_WINDOW_WIDTH(state, width) { state.windowWidth = width },
  // UPDATE_WINDOW_SCROLL_Y(state, val) { state.scrollY = val },

  // // /////////////////////////////////////////////
  // // User/Account
  // // /////////////////////////////////////////////

  // // Updates user info in state and localstorage
  // UPDATE_USER_INFO(state, payload) {

  //   // Get Data localStorage
  //   let userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser

  //   for (const property of Object.keys(payload)) {

  //     if (payload[property] != null) {
  //       // If some of user property is null - user default property defined in state.AppActiveUser
  //       state.AppActiveUser[property] = payload[property]

  //       // Update key in localStorage
  //       userInfo[property] = payload[property]
  //     }

  //   }
  //   // Store data in localStorage
  //   localStorage.setItem("userInfo", JSON.stringify(userInfo))
  // },

  // // /////////////////////////////////////////////
  // // 更新菜单
  // // /////////////////////////////////////////////

  // SET_NAVMENUITEMS(state) {
  //   state.navbarSearchAndPinList = JSON.parse(localStorage.getItem("navMenuItems"));
  // },

  // // /////////////////////////////////////////////
  // // 更新初始数据
  // // /////////////////////////////////////////////
  // SET_ORGS(state, orgs) {
  //   state.orgs = orgs;
  // },

  // GET_ORG(state, orgid) {
  //   state.selectedorg = state.orgs[state.orgs.findIndex(item => item.id == orgid)];
  // },
  // GET_ICON(state, icon) {
  //   console.log('GET_ICON');
  //   console.log('GET_ICON');
  //   console.log('GET_ICON');
  //   state.selectedIcon = state.icons[state.icons.findIndex(item => item.icon == icon)];
  //   console.log(state.selectedIcon);
  // },
  // SET_FORM(state, forms) {
  //   // console.log(forms);
  //   state.forms = forms;
  // },
  // GET_FORM(state, form) {
  //   state.selectedForm = state.forms[state.forms.findIndex(item => item.id == form)];
  // },

  // SET_ROLES(state, roles) {
  //   state.roles = roles;
  // },

  // GET_ROLE(state, roleid) {
  //   state.selectedRole = state.roles[state.roles.findIndex(item => item.id == roleid)];
  // },
  // SET_MENUS(state, menus) {
  //   state.menus = menus;
  // },

  // GET_MENU(state, menuid) {
  //   state.selectedMenu = state.menus[state.menus.findIndex(item => item.id == menuid)];
  // },
  // SET_GOODSCATEGORYS(state, goodscategorys) {
  //   state.goodscategorys = goodscategorys;
  // },
  // UPDATE_NOTIFICATION(state, data) {
  //   let a=state.notifications;
  //   console.log(data);
  //   if(data.length&&data.length>0){
  //     a.push.apply(a,data);
  //   }
  //   // const ids=state.notifications.map(x=>{return x.id} );
  //   // let [...list]=data
  //   // console.log(list);
  //   // const news=list.filter(x=>{
  //   //   return ids.findIndex(x.id)>0
  //   // });
  //   // console.log(news);
  //   // state.notifications=state.notifications.concat(news);

  //   // state.notifications.push(data[0]);
  //   // if(state.notifications!=data){
  //   //   console.log('UPDATE_NOTIFICATION');
  //   //   state.notifications = data;
  //   // }
  // },
  // RESET_NOTIFICATION(state){
  //   state.notifications=[]
  // }
};

export default mutations;
